import client from "./instance";

//CR027 - Get Service Status API Add tconnectid parameter
export const getServiceStatus = async () => {
  try {
    const response = await client.get("/client/cnf-parameter/getServiceStatus");
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

//CR027 - Get Service Status API Add tconnectid parameter
export const getServiceStatusAllowedUser = async (data) => {
  try {
    const response = await client.post('/client/cnf-parameter/getServiceStatusAllowedUser', data);

    return response.data;
  } catch (error) {
    console.log(error)
    throw error;
  }
};

/*
export const getServiceStatusAllowedUser = async (data) => {
  try {
    const response = await client.get(
      "/client/cnf-parameter/getServiceStatusAllowedUser",
      data,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
*/
